export default class EmailPopup {
  //===========================================================================
  // Constructor
  //===========================================================================

  constructor(init) {
    if (init) {
      this.showPopup();
      this.setupKlaviyoForms();
      this.setupEventListeners();
    }
  }

  //===========================================================================
  // Shows the popup on page load
  //===========================================================================

  showPopup() {
    const $popup = $('.js-email-popup');

    if ($popup[0]) {
      const delay = ($popup.data('delay') || 0) * 1000;
      const hasCookie = this.checkCookieStatus();

      if (!hasCookie) {
        setTimeout(() => {
          $popup.fadeIn(500);
          $('html').addClass('no-scroll');
        }, delay);
      }
    }
  }

  //===========================================================================
  // Hides the popup
  //===========================================================================

  hidePopup() {
    $('html').removeClass('no-scroll');
    $('.js-popup').fadeOut(500);
  }

  //===========================================================================
  // The user has submitted their email
  //===========================================================================

  onFormSubmit(e) {
    this.setCookie(true);

    setTimeout(() => {
      this.hidePopup();
    }, 2000);
  }

  //===========================================================================
  // The user has closed the form without submitting their email
  //===========================================================================

  onFormClose(e) {
    const $target = $(e.currentTarget);

    if ($target.is('a')) {
      e.preventDefault();
    }

    this.setCookie(false);
    this.hidePopup();
  }

  //===========================================================================
  // Sets a cookie for the form
  //===========================================================================

  setCookie(submitted) {
    if (submitted) {
      document.cookie = `email_popup_submit=1; path=/`
    } else {
      const $popup = $('.js-email-popup');
      const range = $popup.data('days') || 10;
      let expiryDate = new Date();

      expiryDate.setDate( expiryDate.getDate() + range );
      expiryDate = expiryDate.toUTCString();

      document.cookie = `email_popup_submit=0; expires=${ expiryDate }; path=/`
    }
  }

  //===========================================================================
  // Checks if a cookie has been set
  //===========================================================================

  checkCookieStatus() {
    const cookies = document.cookie.replace(/\s/g, '').split(';');
    let status = false;

    cookies.forEach((cookie) => {
      if (cookie.includes('email_popup_submit')) {
        status = true;
      }
    });

    return status;
  }

  //===========================================================================
  // Initialize Klaviyo Forms
  //===========================================================================

  setupKlaviyoForms() {
    const $forms = $('.js-klaviyo-form');

    $forms.each((i, form) => {
      const $form = $(form);
      const formId = `#${ $form[0].id }`;
      const extra_properties = {};

      if (!$form.hasClass('initialized')) {
        $form.addClass('initialized');

        if ($form.data('source')) { extra_properties['$source'] = $form.data('source') };
        if ($form.data('popup-pdp')) { extra_properties['$popupPDP'] = true };
        if ($form.data('popup-main')) { extra_properties['$popupMain'] = true };

        KlaviyoSubscribe.attachToForms(formId, {
          hide_form_on_success: true,
          custom_success_message: true,
          extra_properties: extra_properties,
          success: function (form) {
            const $parent = $(form).closest('.js-newsletter-form-wrapper');

            $parent.trigger({
              type: 'klaviyoEmailSubmit'
            });
          }
        });
      }
    });
  }

  //===========================================================================
  // When a klaviyo form is submitted
  //===========================================================================

  onKlaviyoSubmit(e) {
    const $target = $(e.currentTarget);

    $target.find('.js-newsletter-form').hide();

    setTimeout(() => {
      this.hidePopup();
    }, 2000);
  }

  //===========================================================================
  // Opens the Back In Stock Popup
  //===========================================================================

  openBisPopup(e) {
    const $target = $(e.currentTarget);
    const $popup = $('.js-email-bis-popup');

    if ($target.is('a')) {
      e.preventDefault();
    }

    $popup.fadeIn(500);
  }

  //===========================================================================
  // Subscribes a customer to a Back In Stock notification.
  //===========================================================================

  onBackInStockFormSubmit(e) {
    const $target = $(e.currentTarget);
    const $popup = $('.js-email-bis-popup');
    const formValues = $target.serializeArray();
    const klaviyoAPI  = $popup.data('public-key');
    const self  = this;
    const data  = {
      a: klaviyoAPI,
      platform: 'shopify'
    };

    e.preventDefault();

    formValues.forEach((obj) => {
      data[obj.name] = obj.value;
    });

    $.ajax({
      type: 'POST',
      url: 'https://a.klaviyo.com/onsite/components/back-in-stock/subscribe',
      data: data,
      dataType: 'json',
      success: function(d) {
        console.log('BIS SUCCESS');
        self.backInStockFormSuccess($target);
      },
      error: function(e) {
        console.log('BIS ERROR');
        console.log(e);
        self.backInStockFormSuccess($target);
      }
    });
  }

  //===========================================================================
  // Updates the variant for the Back In Stock form
  //===========================================================================

  updateBackInStockVariant(e) {
    const $target = $(e.currentTarget);
    const $popup = $('.js-email-bis-popup');
    const $variantField = $popup.find('.js-back-in-stock-variant');
    const variant = e.variant;

    if ($variantField[0] && variant && variant.id) {
      $variantField.val(variant.id);
    }
  }

  //===========================================================================
  // Callback after submitting BIS form.
  //===========================================================================

  backInStockFormSuccess($form) {
    $form.find('.js-bis-form-message').show();
    $form.find('.js-newsletter-form').hide();

    // setTimeout(() => {
    //   this.hidePopup();
    // }, 2000);
  }

  //===========================================================================
  // Sets up event listeners
  //===========================================================================

  setupEventListeners() {
    $(document).on('submit', '.js-email-popup-form form', this.onFormSubmit.bind(this));
    $(document).on('submit', '.js-email-bis-form form', this.onBackInStockFormSubmit.bind(this));
    $(document).on('click', '.js-email-bis-popup-open', this.openBisPopup.bind(this));
    $(document).on('click', '.js-popup-close', this.onFormClose.bind(this));
    $(document).on('klaviyoEmailSubmit', '.js-newsletter-form-wrapper', this.onKlaviyoSubmit.bind(this));
    $(document).on('variantChange', '.js-product-wrapper', this.updateBackInStockVariant.bind(this));
    $(document).on('historyChange', this.setupKlaviyoForms.bind(this));
  }
}
